import { breadcrumbsUpdated } from "./slice";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { IBreadcrumbItem } from "./definitions";

/**
 * Hook for handling breadcrumb redux state
 */
export const useBreadcrumbs = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.breadcrumbs);

    return {
        getBreadcrumbs: () => selector,
        updateBreadcrumbs: (payload: IBreadcrumbItem[]) => dispatch(breadcrumbsUpdated(payload)),
    };
};
